import { RobotActions } from '../utils/constants';
import { trackGoogleAnalyticsEvent } from './googleAnalytics';

/** Maps internal connection values to BPS-296 reporting labels (BT / USB). */
export function analyticsConnectionType(connectionType: string | undefined | null): string {
  if (connectionType === RobotActions.STATE.CONNECTION_TYPE.BLE) return 'BT';
  if (connectionType === RobotActions.STATE.CONNECTION_TYPE.SERIAL) return 'USB';
  return 'unknown';
}

export function trackConnectSelected(connectionType: string | undefined | null): void {
  trackGoogleAnalyticsEvent('bps_connect_selected', {
    connection_type: analyticsConnectionType(connectionType),
  });
}

export function trackConnectSucceeded(connectionType: string | undefined | null, robotName: string): void {
  trackGoogleAnalyticsEvent('bps_connection_succeeded', {
    connection_type: analyticsConnectionType(connectionType),
    robot: robotName,
  });
}

export function trackConnectFailed(connectionType: string | undefined | null, robotName: string): void {
  trackGoogleAnalyticsEvent('bps_connection_failed', {
    connection_type: analyticsConnectionType(connectionType),
    robot: robotName,
  });
}

export function trackFirmwareTransfer(phase: 'started' | 'succeeded' | 'failed', connectionType: string | undefined | null): void {
  const names = {
    started: 'bps_firmware_transfer_started',
    succeeded: 'bps_firmware_transfer_succeeded',
    failed: 'bps_firmware_transfer_failed',
  } as const;
  trackGoogleAnalyticsEvent(names[phase], {
    connection_type: analyticsConnectionType(connectionType),
  });
}

const PROGRAM_PROJECT_TYPE_LABEL = 'Program';

export function trackProjectCreated(): void {
  trackGoogleAnalyticsEvent('bps_project_created', {
    project_type: PROGRAM_PROJECT_TYPE_LABEL,
  });
}

export function trackRapidRobotTemplateCreateClick(templateKey: string): void {
  trackGoogleAnalyticsEvent('bps_rr_template_create_click', {
    robot_template: templateKey,
  });
}

export function trackEditorTabClick(tab: 'program' | 'dashboard' | 'path_builder'): void {
  trackGoogleAnalyticsEvent('bps_editor_tab_click', { editor_tab: tab });
}

export function trackProjectOpened(): void {
  trackGoogleAnalyticsEvent('bps_project_opened', {
    project_type: PROGRAM_PROJECT_TYPE_LABEL,
  });
}

export function trackDeployClicked(deployType: 'Deploy' | 'Deploy & Run' | 'Run'): void {
  trackGoogleAnalyticsEvent('bps_deploy_clicked', { deploy_type: deployType });
}
